var map = {
	"./4": 28,
	"./4.png": 28,
	"./5": 29,
	"./5.png": 29,
	"./6": 30,
	"./6.png": 30,
	"./bank-logo": 31,
	"./bank-logo.png": 31,
	"./bg-1": 32,
	"./bg-1.jpg": 32,
	"./bg-2": 33,
	"./bg-2.jpg": 33,
	"./bizzly-logo": 34,
	"./bizzly-logo.png": 34,
	"./branding-example": 35,
	"./branding-example.png": 35,
	"./cover-4": 36,
	"./cover-4.jpg": 36,
	"./cover-5": 37,
	"./cover-5.jpg": 37,
	"./features/invoice-screenshot": 38,
	"./features/invoice-screenshot.png": 38,
	"./features/quote-screenshot": 39,
	"./features/quote-screenshot.png": 39,
	"./features/report-screenshot": 40,
	"./features/report-screenshot.png": 40,
	"./home/dashboard": 41,
	"./home/dashboard.png": 41,
	"./illustrations/bg-shape": 42,
	"./illustrations/bg-shape.png": 42,
	"./illustrations/bg-shop": 43,
	"./illustrations/bg-shop.png": 43,
	"./illustrations/corner-1": 44,
	"./illustrations/corner-1.png": 44,
	"./illustrations/corner-2": 45,
	"./illustrations/corner-2.png": 45,
	"./illustrations/corner-3": 46,
	"./illustrations/corner-3.png": 46,
	"./illustrations/corner-4": 47,
	"./illustrations/corner-4.png": 47,
	"./illustrations/half-circle": 48,
	"./illustrations/half-circle.png": 48,
	"./illustrations/shape-1": 49,
	"./illustrations/shape-1.png": 49,
	"./payid-logo": 50,
	"./payid-logo.png": 50,
	"./public-dashboard-alt": 51,
	"./public-dashboard-alt.jpg": 51,
	"./stripe-logo": 52,
	"./stripe-logo.png": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;